import { gql } from '@apollo/client/core';

export const updateFacility = gql`
  mutation updateFacility($id: String, $input: UpdateFacilityInput) {
    updateFacility(id: $id, input: $input) {
      id
      ContactListId
      managementContactListId
      Locations {
        id
        state
        county
        township
      }
      address
      facilityName
      facilityUid
      FacilityType {
        id
        name
      }
      AORs {
        id
        name
      }
      Company {
        id
        name
      }
      businessUnit {
        id
      }
      notes
      phone
      altPhone
      gps
      scadaId
      flocNumber
      timezone
      updater
      deletedAt
      version
      area {
        id
        name
        region {
          id
          name
        }
      }
      owner {
        id
        firstName
        lastName
        nickName
      }
      NotepadEntries {
        id
        categoryId
        note
        archived
        createdBy
        createdAt
        updater
        updatedAt
        Category {
          id
          name
        }
      }
      hidden
      autoSignout
      AdditionalResourceLists {
        id
        name
        ContactListMembers {
          id
          order
          Contact {
            id
            firstName
            lastName
            nickName
            adAccountName
            otherPhone
            speedDial
            businessMobile
            businessPhone
            afterHoursPhoneNumber
            home
            other
            personalMobile
            Company {
              id
              name
              abbreviation
              version
            }
            WhenUnavailable {
              id
              firstName
              lastName
            }
            JobRole {
              id
              name
            }
            ReportsTo {
              id
              firstName
              lastName
              businessMobile
              ReportsTo {
                id
                firstName
                lastName
                businessMobile
              }
              version
            }
          }
        }
        AdditionalResourceListType {
          id
          name
          enabled
        }
      }
    }
  }
`;
